<template>
  <div class="google-signin-success">
    <h1>{{ message }}</h1>
    <p class="welcome">Welcome, {{ userInfo.name }}!</p>
    <img
      class="user-image"
      v-if="userInfo?.picture && !loadImageError"
      :src="userInfo.picture"
      @error="loadImageError = true"
    />
    <div v-else class="no-image">
      <div>
        <img src="@/assets/user.svg" />
      </div>
    </div>
    <div class="redirect-message">
      You are about to be redirected to
      <span>{{ subDomain }}.{{ hostname }}</span
      >...
    </div>
  </div>
</template>

<script>
export default {
  name: "GoogleSignInCompleted",
  props: {
    message: {
      type: String,
      default: "Sign In Successful",
    },
    userInfo: {
      type: Object,
      required: true,
    },
    subDomain: {
      type: String,
      required: true,
    },
    returnPath: {
      type: String,
      default: "",
    },
    loginKey: {
      type: String,
      default: null,
    },
    tenantId: {
      type: String,
      default: null,
    },
    hostname: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loadImageError: false,
    };
  },
  methods: {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import "@/styles/themeColor.scss";
.google-signin-success {
  text-align: center;
  padding: 20px;

  h1 {
    font-size: 24px;
    margin-bottom: 20px;
    color: $theme-color;
  }

  p {
    margin: 30px 0 20px 0;
  }
  .welcome {
    font-size: 18px;
    color: $theme-color;
  }

  .user-image {
    pointer-events: none;
    user-select: none;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    min-width: 100px;
    min-height: 100px;
    object-fit: cover;
  }
  .no-image {
    pointer-events: none;
    user-select: none;
    display: grid;
    place-items: center;
    width: 100%;
    div {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      background-color: #eee;
      display: grid;
      align-items: end;
      justify-items: center;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        opacity: 0.1;
        object-fit: cover;
        transform: translateY(15px);
      }
    }
  }
  .redirect-message {
    margin-top: 40px;
    color: #666;
    span {
      color: $theme-color;
    }
  }
}
</style>
